const s = {
  page: { minHeight: '100vh', backgroundColor: '#f8f9fa', fontFamily: 'Inter, sans-serif', padding: '40px 20px' },
  card: { maxWidth: '800px', margin: '0 auto', backgroundColor: '#fff', borderRadius: '12px', boxShadow: '0 2px 16px rgba(0,0,0,0.08)', padding: '48px' },
  header: { textAlign: 'center' as const, marginBottom: '40px', borderBottom: '2px solid #FF6A3D', paddingBottom: '24px' },
  logo: { fontSize: '28px', fontWeight: 800, color: '#FF6A3D', marginBottom: '8px' },
  subtitle: { color: '#666', fontSize: '14px' },
  h2: { fontSize: '18px', fontWeight: 700, color: '#1a1a1a', marginTop: '32px', marginBottom: '12px' },
  p: { color: '#444', lineHeight: 1.7, fontSize: '15px', marginBottom: '12px' },
  ul: { color: '#444', lineHeight: 1.8, fontSize: '15px', paddingLeft: '20px', marginBottom: '12px' },
  footer: { marginTop: '40px', paddingTop: '24px', borderTop: '1px solid #eee', textAlign: 'center' as const, color: '#999', fontSize: '13px' },
};

export const PrivacyRepartidorPage = () => (
  <div style={s.page}>
    <div style={s.card}>
      <div style={s.header}>
        <div style={s.logo}>EncoreEats</div>
        <div style={{ fontSize: '22px', fontWeight: 700, color: '#1a1a1a', marginBottom: '6px' }}>Política de Privacidad</div>
        <div style={s.subtitle}>Aplicación para Repartidores · Última actualización: 29 de abril de 2026</div>
      </div>

      <p style={s.p}>
        En <strong>EncoreEats</strong> nos comprometemos a proteger su privacidad. Esta política describe cómo recopilamos, usamos y protegemos la información de los repartidores cuando utilizan nuestra aplicación de entrega.
      </p>

      <h2 style={s.h2}>1. Información que recopilamos</h2>
      <p style={s.p}>Recopilamos la siguiente información cuando usa nuestra aplicación:</p>
      <ul style={s.ul}>
        <li>Nombre completo, correo electrónico y número de teléfono</li>
        <li>Documento de identidad y datos para verificación de identidad</li>
        <li>Ubicación geográfica en tiempo real durante las entregas activas</li>
        <li>Historial de entregas realizadas y calificaciones recibidas</li>
        <li>Foto de perfil para identificación ante clientes y restaurantes</li>
        <li>Token de notificaciones push para alertas de nuevos pedidos asignados</li>
        <li>Datos bancarios para el procesamiento de pagos por entregas</li>
      </ul>

      <h2 style={s.h2}>2. Permisos que utiliza la aplicación</h2>
      <ul style={s.ul}>
        <li><strong>Ubicación (en primer plano y segundo plano):</strong> para rastrear la ruta de entrega, mostrar su posición al cliente y optimizar la asignación de pedidos cercanos</li>
        <li><strong>Cámara:</strong> para tomar foto de perfil y confirmar entregas cuando se requiera</li>
        <li><strong>Notificaciones:</strong> para recibir alertas de nuevos pedidos disponibles y actualizaciones de entregas asignadas</li>
        <li><strong>Almacenamiento:</strong> para acceder a fotos del dispositivo al actualizar el perfil</li>
      </ul>

      <h2 style={s.h2}>3. Cómo usamos su información</h2>
      <ul style={s.ul}>
        <li>Asignar pedidos disponibles según su ubicación y disponibilidad</li>
        <li>Compartir su ubicación en tiempo real con el cliente durante la entrega</li>
        <li>Calcular y procesar los pagos por las entregas completadas</li>
        <li>Generar reportes de actividad y desempeño</li>
        <li>Garantizar la seguridad del proceso de entrega</li>
        <li>Cumplir con requisitos legales y fiscales</li>
      </ul>

      <h2 style={s.h2}>4. Uso de la ubicación</h2>
      <p style={s.p}>
        La ubicación en tiempo real solo se activa cuando usted está en modo activo realizando una entrega. Esta información se comparte temporalmente con el cliente que espera su pedido y con nuestra plataforma para optimizar las rutas. <strong>No almacenamos su historial de ubicación</strong> una vez finalizada la entrega.
      </p>

      <h2 style={s.h2}>5. Servicios de terceros</h2>
      <p style={s.p}>Utilizamos los siguientes servicios de terceros:</p>
      <ul style={s.ul}>
        <li><strong>Firebase (Google):</strong> autenticación, base de datos y almacenamiento</li>
        <li><strong>Google Maps:</strong> navegación y cálculo de rutas de entrega</li>
        <li><strong>Expo:</strong> infraestructura para notificaciones push</li>
      </ul>

      <h2 style={s.h2}>6. Retención de datos</h2>
      <p style={s.p}>
        Sus datos personales se conservan mientras su cuenta esté activa. El historial de entregas se retiene por motivos contables durante el período requerido por la legislación aplicable. Puede solicitar la eliminación de su cuenta en cualquier momento.
      </p>

      <h2 style={s.h2}>7. Seguridad</h2>
      <p style={s.p}>
        Toda comunicación entre la aplicación y nuestros servidores se realiza mediante cifrado HTTPS. Implementamos controles de acceso estrictos para proteger sus datos personales y financieros.
      </p>

      <h2 style={s.h2}>8. Sus derechos</h2>
      <ul style={s.ul}>
        <li>Acceder a sus datos personales y historial de entregas</li>
        <li>Corregir información incorrecta en su perfil</li>
        <li>Solicitar la eliminación de su cuenta y datos</li>
        <li>Oponerse al tratamiento de sus datos en cualquier momento</li>
      </ul>

      <h2 style={s.h2}>9. Contacto</h2>
      <p style={s.p}>
        Si tiene preguntas sobre esta política de privacidad o desea ejercer sus derechos, contáctenos en:<br />
        <strong>encoreeat@gmail.com</strong>
      </p>

      <div style={s.footer}>
        © 2026 EncoreEats. Todos los derechos reservados.
      </div>
    </div>
  </div>
);
